import React, { PureComponent } from 'react'
import { withStyles } from '@material-ui/core/styles/index'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import InputAdornment from '@material-ui/core/InputAdornment'
import { storeOffer } from '../../../api'

const styles = theme => ({
    root: {
        width: '100%',
        //maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #e0e0e0',
        marginBottom: theme.spacing(2)
    },
    chip: {
        marginLeft: theme.spacing(1),
        //marginBottom: theme.spacing.unit * 1,
        minWidth: 60,
        whiteSpace: 'pre-wrap'
    },
    singleChip: {
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(1)
    },
    confirmedChip: {
        background: '#43a047',
        color: 'white'
    },
    question: {
        fontWeight: 400,
        paddingLeft: 0
    },
    section1: {
        margin: `${theme.spacing(3)}px ${theme.spacing(2)}px`
    },
    section2: {
        margin: theme.spacing(2)
    },
    section3: {
        margin: `${theme.spacing(3)}px ${theme.spacing(2)}px ${theme.spacing(2)}px`
    },
    titleSection: {
        padding: theme.spacing(2),
        borderLeft: theme.spacing(1) + 'px solid ' + theme.palette.primary[500],
        borderBottom: '1px solid #e0e0e0'
    },
    mainTitleSection: {
        padding: theme.spacing(2),
        borderLeft: theme.spacing(2) + 'px solid ' + theme.palette.primary[700],
        borderBottom: '1px solid #e0e0e0',
        background: theme.palette.primary[500]
    },
    statusSection: {
        margin: `${theme.spacing(1)}px ${theme.spacing(2)}px ${theme.spacing(1)}px`
    },
    title: {
        fontWeight: 500,
        fontSize: '1.2rem'
    },
    titleInfo: {
        fontWeight: 400,
        fontSize: '1.1rem',
        textAlign: 'left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        [theme.breakpoints.up(600)]: {
            textAlign: 'right',
            paddingRight: theme.spacing(1) + 'px!important'
        }
    },
    chipWrapper: {
        marginBottom: theme.spacing(1)
    },
    tableCell: {
        padding: `${theme.spacing(1)}px ${theme.spacing(0)}px ${theme.spacing(1)}px ${theme.spacing(1)}px`
    },
    thRowCell: {
        height: 45
    },
    lastRowCell: {
        borderBottom: 'none'
    },
    lastColumnCell: {
        paddingRight: theme.spacing(1) + 'px!important'
    },
    gaugeTitle: {
        textAlign: 'center',
        marginTop: theme.spacing(1)
    },
    statusBlue: {
        background: '#f7f7f7',
        border: '1px solid #e0e0e0',
        marginBottom: -1
    },
    statusText: {
        //color: 'white',
        fontWeight: 500,
        fontSize: '0.9rem'
    },
    tableSection: {
        marginBottom: theme.spacing(1)
    },
    formControl: {
        maxWidth: 75
    },
    leftIcon: {
        marginRight: 10,
        marginLeft: -3
    },
    answer: {
        fontSize: '1rem',
        fontWeight: 500
    },
    unit: {
        fontSize: '0.875rem',
        color: 'rgba(0, 0, 0, 0.54)',
        marginLeft: theme.spacing(1)
    }
})

class Offer extends PureComponent {
    state = {
        questionValues: [],
        editOffer: false
    }

    componentDidMount() {
        this.updateQuestionValues(this.props)
    }

    componentWillReceiveProps(nextProps) {
        this.updateQuestionValues(nextProps)
    }

    updateQuestionValues = props => {
        const offer = props.application.offer
        if (offer) {
            const currentOffer = offer.currentOffer
            if (currentOffer) {
                let questionValues = []
                for (let answer of currentOffer.answersArray) {
                    questionValues.push({ id: answer.questionId, value: answer.answer })
                }
                this.setState({ questionValues: questionValues })
            }
        }
    }

    onToggleEditOffer = () => {
        this.setState({ editOffer: !this.state.editOffer })
    }

    onSubmit = action => {
        const application = this.props.application
        const offerType = application.offer.offerType
        const answers = this.state.questionValues

        storeOffer({ applicationId: this.props.application.id, offerTypeId: offerType.id, answers: answers }).then(() => {
            this.props.refresh().then(() => {
                this.setState({ editOffer: false })
            })
        })
    }

    onQuestionValueChanged = (id, value) => {
        let questionValues = this.state.questionValues
        let questionIndex = questionValues.findIndex(x => x.id === id)
        if (questionIndex < 0) {
            const questionValue = { id: id, value: value }
            questionValues.push(questionValue)
        } else {
            questionValues[questionIndex].value = value
        }
        this.setState({ questionValues: questionValues })
        this.forceUpdate()
    }

    getQuestionValue = id => {
        const questionValues = this.state.questionValues
        const questionIndex = questionValues.findIndex(x => x.id === id)

        if (questionIndex < 0) {
            return ''
        } else {
            return questionValues[questionIndex].value
        }
    }

    render() {
        const { classes, application, user } = this.props
        const { questionValues, editOffer } = this.state

        const offer = application.offer
        const questions = offer.questions
        const currentOffer = offer.currentOffer
        const hasPermissionToEditOffer = !!(user && (user.permission === 'client' || user.permission === 'admin'))

        return (
            <div className={classes.root}>
                <div className={classes.titleSection}>
                    <Grid container alignItems="center">
                        <Grid item sm={12} md={12}>
                            <Typography variant="h5" className={classes.title}>
                                {offer.title}
                            </Typography>
                        </Grid>
                    </Grid>
                </div>
                {currentOffer && !editOffer && (
                    <div className={classes.section2 + ' ' + classes.tableSection} style={{ marginTop: 4 }}>
                        <Table className={classes.table}>
                            <TableBody>
                                {currentOffer.answersArray.map((answer, key) => {
                                    return (
                                        <TableRow key={key}>
                                            <TableCell component="th" variant="body1" className={classes.tableCell + ' ' + classes.question}>
                                                {answer.title}
                                            </TableCell>
                                            <TableCell align="right" className={classes.tableCell + ' ' + classes.lastColumnCell}>
                                                <span className={classes.answer}>{answer.answer}</span>
                                                <span className={classes.unit}>{answer.unit}</span>
                                            </TableCell>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </div>
                )}
                {hasPermissionToEditOffer && !editOffer && (
                    <div className={classes.section3}>
                        {!currentOffer && (
                            <Button variant="contained" color="primary" fullWidth onClick={() => this.onToggleEditOffer()}>
                                <FontAwesomeIcon size={'lg'} icon={['fal', 'pencil']} className={classes.leftIcon} />
                                Tee tarjous
                            </Button>
                        )}

                        {currentOffer && (
                            <Button variant="outlined" color="primary" fullWidth onClick={() => this.onToggleEditOffer()}>
                                <FontAwesomeIcon size={'lg'} icon={['fal', 'pencil']} className={classes.leftIcon} />
                                Muokkaa tarjousta
                            </Button>
                        )}
                    </div>
                )}
                {!hasPermissionToEditOffer && !currentOffer && (
                    <div className={classes.section2}>
                        <Typography variant="body2">
                            <i>Rahoittaja ei ole vielä tehnyt alustavaa tarjousta.</i>
                        </Typography>
                    </div>
                )}
                {hasPermissionToEditOffer && editOffer && (
                    <>
                        <div className={classes.section2 + ' ' + classes.tableSection} style={{ marginTop: 4 }}>
                            <Table className={classes.table}>
                                <TableBody>
                                    {questions.map((question, key) => {
                                        return (
                                            <TableRow key={key}>
                                                <TableCell component="th" variant="body1" className={classes.tableCell + ' ' + classes.question}>
                                                    {question.title}
                                                </TableCell>
                                                <TableCell align="right" className={classes.tableCell + ' ' + classes.lastColumnCell}>
                                                    <FormControl className={classes.formControl}>
                                                        <Input
                                                            value={this.getQuestionValue(question.id)}
                                                            onChange={() => this.onQuestionValueChanged(question.id, event.target.value)}
                                                            endAdornment={<InputAdornment position="end">{question.unit}</InputAdornment>}
                                                            labelWidth={0}
                                                            defaultValue={question.value}
                                                        />
                                                    </FormControl>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </div>
                        <Grid container alignItems="center" style={{ marginTop: -8 }}>
                            <Grid item sm={6} md={6}>
                                <div className={classes.section3}>
                                    <Button variant="outlined" color="primary" fullWidth onClick={() => this.onToggleEditOffer()}>
                                        Takaisin
                                    </Button>
                                </div>
                            </Grid>
                            <Grid item sm={6} md={6}>
                                <div className={classes.section3}>
                                    <Button variant="contained" color="primary" fullWidth onClick={() => this.onSubmit(offer.action.action)}>
                                        <FontAwesomeIcon size={'lg'} icon={['fal', 'save']} className={classes.leftIcon} />
                                        Lähetä tarjous
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </>
                )}
            </div>
        )
    }
}

export default withStyles(styles)(Offer)
